import Module from '../../utils/modules/Module';
import algoliasearch from 'algoliasearch';
import Handlebars from 'handlebars';
import EventsManager from "../../utils/events/EventsManager";
import CustomEvents from "../../utils/events/CustomEvents";

export default class SearchModule extends Module {
  constructor(options) {
    super(options);

    // Setup index
    const client = algoliasearch(Globals.algolia_app_id, Globals.algolia_search_key);
    const indexName = (Globals.environment === 'prod') ? 'default_' + Globals.langcode : 'test_' + Globals.langcode;

    this.index = client.initIndex(indexName);
    this.index_date_desc = client.initIndex(indexName + '_date_desc');
    this.index_title_asc = client.initIndex(indexName + '_title_asc');
    this.index_title_desc = client.initIndex(indexName + '_title_desc');
    this.index_year_approved_desc = client.initIndex(indexName + '_year_approved_desc');
    this.index_prohibited_item_weight_asc = client.initIndex(indexName + '_prohibited_item_weight_asc');

    this.searchParams = {
      distinct: true,
      hitsPerPage: 12,
      responseFields: [
        'hits',
        'nbHits',
        'facets',
        'offset',
        'length',
      ],
      attributesToRetrieve: ['*'],
      facets: ['*'],
    };

    this.searchWithFilters = this.searchWithFilters.bind(this);
    this.filteredContent = this.filteredContent.bind(this);

    EventsManager.on(CustomEvents.search.SEARCH_WITH_FILTERS, this.searchWithFilters);
  }

  /**
   * @param searchQuery
   * @param filters
   * @param currentVid
   * @param $resultsContainer
   * @param $filterContainer
   * @param offset
   */
  searchWithFilters({searchQuery, filters, currentVid, $resultsContainer, $filterContainer, offset = 0}) {
    let callback;
    let $form = ($filterContainer !== null) ? $filterContainer.closest('form') : $resultsContainer.closest('.search-block').querySelector('form');
    let params = {};

    params.length = parseInt($form.getAttribute('data-limit'));
    params.offset = offset * params.length;
    params.filters = filters;
    params.aroundLatLng = '';
    params.aroundRadius = '';
    params.insidePolygon = '';

    if (typeof ($form.getAttribute('data-display-mode')) !== 'undefined') {
      let displayMode = $form.getAttribute('data-display-mode');

      params.attributesToRetrieve = [displayMode];

      if (displayMode === 'search_result') {
        params.getRankingInfo = true;
        params.attributesToRetrieve.push('promoted');
      }
    }

    callback = this.filteredContent;

    this.search(searchQuery, params, callback, currentVid, $resultsContainer, $filterContainer);
  }

  /** ------------------------------
   * Events
   --------------------------------- */
  /**
   * Pagination click event
   * @param ev
   */
  onSearchPaginationClick(ev) {
    ev.preventDefault();

    let $this = ev.targetElement,
      $searchContainer = $this.closest('.search-block'),
      page = parseInt($this.getAttribute('data-page')),
      $filters = $searchContainer.querySelector('form.filters');

    $searchContainer.querySelector('input[name=page]').value = page;
    // CossetteFilters.submitFiltersSearchMain($filters);
    EventsManager.broadcast(CustomEvents.search.SUBMIT_FILTERS, $filters);

    // CossetteApp.scrollTo($searchContainer.get(0), null, -50, 50);
    document.querySelector($searchContainer).scrollIntoView({
      behavior: 'smooth',
    });
  }

  /** ------------------------------
   * Callbacks
   --------------------------------- */
  /**
   * Callback to display content
   * @param hits
   * @param $resultsContainer
   */
  filteredContent(hits, $resultsContainer) {
    const $sectionContainer = $resultsContainer.closest('.search-block');
    const $form = $sectionContainer.querySelector('form');
    const displayMode = $form.hasAttribute('data-display-mode') ? $form.getAttribute('data-display-mode') : 'teaser';
    const $disclaimer = document.getElementById('disclaimer-wrapper');

    let $promoted = '';
    let promotedCount = 0;
    let $html = '';

    if (hits.hasOwnProperty('nbHits') && hits.nbHits > 0) {
      for (let hit of hits.hits) {
        if (displayMode === 'search_result' && hit._rankingInfo.hasOwnProperty('promoted')) {
          $promoted = hit['promoted'];
          promotedCount++;
        }

        $html += `<li class="list-item-wrapper">${hit[displayMode]}</li>`;
      }

      $html = `<ul class="list">${$html}</ul>`;

      $resultsContainer.querySelector('.teasers-container .list-wrapper').innerHTML = $html;

      if (document.querySelector('div.pagination')) {
        let nbPages = Math.ceil(hits.nbHits / hits.length);

        this.buildPager(document.querySelector('div.pagination'), Math.floor(hits.offset / hits.length), nbPages);

        nbPages === 1 ? document.querySelector('.pagination').style.display = 'none' : document.querySelector('div.pagination').style.display = 'initial';
      }

      this.updatingSearchSummary($resultsContainer, hits);

      if ($disclaimer !==  null) {
        $disclaimer.classList.add('has-results');
      }
    }
    else {
      document.querySelector('.teasers-container .list-wrapper').innerHTML = `<ul class="list"></ul><p>${Drupal.t('No results')}</p>`;

      const $pager = document.querySelector('div.pagination ul');

      if ($pager !== null) {
        $pager.innerHTML = '';

        document.querySelector('.pagination').style.display = 'none';
      }

      this.updatingSearchSummary($resultsContainer, hits);

      if ($disclaimer !==  null) {
        $disclaimer.classList.remove('has-results');
      }
    }

    document.querySelector('.reader-result-num').innerHTML = hits.nbHits;
  }

  /**
   * Main Search function
   * @param searchQuery
   * @param params
   * @param callback
   * @param currentVid
   * @param $resultsContainer
   * @param $filtersContainer
   */
  search(searchQuery, params, callback, currentVid, $resultsContainer, $filtersContainer = null) {
    // Always reset filters if none are passed
    if (typeof (params.filters) === 'undefined') params.filters = '';

    const searchParams = Object.assign(this.searchParams, params);

    // When we search only list of events, make sure we don't show past
    if (searchParams.filters === 'content_type:event') {
      let today = Math.floor(Date.now() / 1000);

      searchParams.filters += ` AND (event_date_start >= ${today})`;
    }

    // Determine which index to use
    let indexToUse;

    if (document.querySelector('form.prohibited.filters')) {
      indexToUse = this.index_prohibited_item_weight_asc;
    }
    else {
      indexToUse = this.index_date_desc;

      let sortBy = document.querySelector('input[name="sort-by"]:checked');

      if (sortBy && sortBy.value !== '') {
        switch (sortBy.value) {
          case 'relevance':
            indexToUse = this.index;
            break;
          case 'title_asc':
            indexToUse = this.index_title_asc;
            break;
          case 'title_desc':
            indexToUse = this.index_title_desc;
            break;
          case 'date_desc':
            indexToUse = this.index_date_desc;
            break;
          case 'year-approved':
            indexToUse = this.index_year_approved_desc;
            break;
          default:
            indexToUse = this.index;
        }
      }
    }

    indexToUse.search(searchQuery, searchParams).then((hits) => {
      callback(hits, $resultsContainer);

      if ($filtersContainer !== null) {
        const eventParams = {
          $container: $filtersContainer,
          facets: hits.facets,
          currentVid: currentVid,
        };

        EventsManager.broadcast(CustomEvents.search.UPDATE_FILTERS, eventParams);
      }
    });
  };

  /**
   * Build the pager for results
   * @param $container
   * @param current
   * @param total
   */
  buildPager($container, current, total) {
    current = parseInt(current);
    total = parseInt(total);

    let $ulContainer = $container.querySelector('ul.pager__items');

    // If only one page: clear pagination and hide it
    if (total === 1) {
      $container.classList.add('is-hidden');

      $ulContainer.innerHTML = '';

      return;
    }

    $container.classList.remove('is-hidden');

    let queryString = window.location.search;

    if (queryString.length === 0) {
      queryString = '?';
    }
    else {
      queryString += '&';
    }

    let limit = 3;
    let liClassPrev = (current === 0) ? 'pager__item--previous is-inactive' : 'pager__item--previous';
    let liClassNext = (current === total - 1) ? 'pager__item--next is-inactive' : 'pager__item--next';
    let pages = [];

    if (current === 0) {
      pages = [
        {
          page: 0,
          label: Drupal.t('Previous'),
          liClass: liClassPrev,
          icon: 'prev',
        },
      ];

      let loopLimit = (total > current + limit) ? current + limit : total;

      for (let i = 0; i < loopLimit; i++) {
        let obj = { page: i, label: i + 1, queryString: queryString + 'page=' + i };

        if (i === current) {
          obj.current = true;
        }

        pages.push(obj);
      }
    }
    else {
      pages = [
        {
          page: current - 1,
          label: Drupal.t('Previous'),
          liClass: liClassPrev,
          icon: 'prev',
          queryString: queryString + 'page=' + (current - 1),
        },
        {
          page: 0,
          label: 1,
          queryString: queryString + 'page=' + 0,
        },
      ];

      if (current > limit - 1) {
        pages.push({
          label: '...',
          liClass: 'pager__item--ellipsis',
        });
      }

      let loopLimit = (current < total - limit) ? current + limit - 1 : total;

      let inferiorLimit = (current === total - 1 && current - 2 > 0) ? current - 2 : current - 1;

      for (let i = inferiorLimit; i < loopLimit; i++) {
        if (i + 1 === 1) {
          continue;
        }

        let obj = { page: i, label: i + 1, queryString: queryString + 'page=' + i };

        if (i === current) {
          obj.current = true;
        }

        pages.push(obj);
      }
    }

    if (current < total - limit) {
      pages.push({
        label: '...',
        liClass: 'pager__item--ellipsis',
      });

      pages.push({
        page: total - 1,
        label: total,
        queryString: queryString + 'page=' + (total - 1),
      });
    }

    if (current !== total) {
      pages.push({
        page: current + 1,
        label: Drupal.t('Next'),
        liClass: liClassNext,
        icon: 'next',
        queryString: queryString + 'page=' + (current + 1),
      });
    }

    let template;

    template = Handlebars.compile(this.TMPLPaginationLinks());

    let $html = '';

    for (const page of pages) {
      if (page.label < 10) {
        page.label = '0'+page.label;
      }

      $html += template(page);
    }

    $ulContainer.innerHTML = $html;
  }

  /**
   * Update number of results summary
   * @param $resultsContainer
   * @param hits
   */
  updatingSearchSummary($resultsContainer, hits) {
    let $container = $resultsContainer.closest('.search-block');
    let $searchField = $container.querySelector('input[name=q]');

    // Update search summary.
    if ($container !== null) {
      $container.querySelectorAll('.result-count').forEach((el) => {
        el.innerHTML = hits.nbHits;
      });

      $container.querySelectorAll('.result-text').forEach((el) => {
        el.innerHTML = hits.nbHits <= 1 ? Drupal.t('result') : Drupal.t('results');
      });
    }

    // Update search autocomplete.
    let $autocompleteSummary = $container.querySelector('.autocomplete-value');

    if ($autocompleteSummary !== null && $searchField !== null) {
      $autocompleteSummary.innerHTML = $searchField.value;
    }
  }

  /** ------------------------------
   * TEMPLATES
   --------------------------------- */
  TMPLPaginationLinks() {
    return `
      <li class="pager__item{{#if liClass}} {{liClass}}{{/if}} {{#if current}}is-active{{/if}}">
        {{#if queryString}}
          <a href="{{ queryString }}" class="{{#if icon}}{{else}}pager__item_link{{/if}}" data-page="{{ page }}"{{#if current}} title="` + Drupal.t('Current page') + `"{{/if}}>
            {{~#if icon ~}}
              <span class="visually-hidden">{{~ label ~}}</span>
              <svg class="arrow-long" aria-hidden="true">
                <use xlink:href="#arrow-long"/>
              </svg>
            {{~ else ~}}
              <span class="visually-hidden">{{~#if current ~}}` + Drupal.t('Current page') + `{{~ else ~}}Page{{~/if~}} </span>
              {{~ label ~}}
            {{~/if~}}
          </a>
        {{else}}
          {{#if icon}}
            <span class="visually-hidden">{{~ label ~}}</span>
            <svg class="arrow-long" aria-hidden="true">
              <use xlink:href="#arrow-long"/>
            </svg>
          {{else}}
            <span>{{~ label ~}}</span>
          {{/if}}
        {{/if}}
      </li>
    `;
  }

}
